import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import admins from '../modules/admins/store';
import auth from '../common/auth/store';
import tenant from '../common/tenant/store';
import tenants from '../modules/tenants/store';
import status from '../common/status/store';
import adminActions from '../modules/admins/actions/store';
import adapterRuns from '../modules/adapterRuns/store';
import APIKeys from '../modules/API-Keys/store';
import adapters from '../modules/adapters/store';

Vue.use(Vuex);

const state = {};

const getters = {};

const mutations = {};

const actions = {
	load({ state, commit, rootGetters, dispatch }) {
		// if (auth.token) {
		// 	dispatch('auth/load');
		// }
		dispatch('auth/load');
		//dispatch('users/load');
		//dispatch('planning/load');
	},
};

const modules = {
	admins,
	auth,
	tenant,
	tenants,
	status,
	adminActions,
	adapterRuns,
	APIKeys,
	adapters,
};

export default new Vuex.Store({
	plugins: [
		createPersistedState({
			storage: window.sessionStorage,
			paths: ['auth'],
		}),
	],
	strict: process.env.NODE_ENV !== 'production',
	state,
	getters,
	mutations,
	actions,
	modules,
});
